import React from "react";
import { Box } from "@mui/material";
import { DocumentHead } from "../components/common/DocumentHead";
import { JsonLd } from "../components/common/JsonLd";
import { ROUTES } from "../config";
import Hero from "../components/sections/Hero";
import HowItWorks from "../components/sections/HowItWorks";
import PlatformPreview from "../components/sections/PlatformPreview";
import CaseStudy from "../components/sections/CaseStudy";
import Pricing from "../components/sections/Pricing";

const HOME_TITLE = "Rusha — The Engineering Control Plane";
const HOME_DESCRIPTION =
  "Build, deploy, and operate your applications on one platform. GitOps workflows, starter templates, FinOps, and AI recommendations. Ship the same way, every time.";

const HomePage: React.FC = () => {
  return (
    <Box component="main" id="main">
      <DocumentHead
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        path={ROUTES.HOME}
      />
      <JsonLd
        data={{
          "@type": "Organization",
          name: "Rusha",
          url: "https://rusha.io",
          logo: "https://rusha.io/favicon.svg",
          description: HOME_DESCRIPTION,
        }}
      />
      <JsonLd
        data={{
          "@type": "WebSite",
          name: "Rusha",
          url: "https://rusha.io",
        }}
      />
      <JsonLd
        data={{
          "@type": "SoftwareApplication",
          name: "Rusha",
          applicationCategory: "DeveloperApplication",
          operatingSystem: "Web",
          description: HOME_DESCRIPTION,
          url: "https://rusha.io",
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
          },
        }}
      />
      <Hero />
      <HowItWorks />
      <PlatformPreview />
      <CaseStudy />
      <Pricing />
    </Box>
  );
};

export default HomePage;
